import { useSelector } from "react-redux";

export default function useIsUsAccount() {
    const { userToken } = useSelector((state) => state.sharedState);

    const roles = Array.isArray(userToken?.role)
        ? userToken.role
        : [userToken?.role ?? "User"];

    const hasAccessUs = roles.some((role) =>
        role.toUpperCase().includes("ACCESSUS")
    );

    return hasAccessUs;
}
